/** @format */

import { useMutation } from "@tanstack/react-query";
import service from "../service/service";

const saveWeather = (data) => {
  if ("temperatureImage" in data && "precipitationImage" in data) {
    return service.saveWeather(data);
  }
  if ("image1" in data) {
    return service.saveSAWeather(data);
  }
};
const useSaveWeather = () =>
  useMutation({
    mutationKey: ["saveWeather"],
    mutationFn: (weather) => {
      let api__data = {
        reportDate: weather.reportDate,
        regionId: weather.regionId,
        productLineId: weather.productLineId,
        headerImagePath: weather.headerImagePath,
        content: weather.content,
        title: weather.title,
        id: weather.id,
      };
      if ("temperatureImage" in weather && "precipitationImage" in weather) {
        api__data.temperatureImage = weather.temperatureImage ?? "";
        api__data.precipitationImage = weather.precipitationImage ?? "";
      }
      if ("image1" in weather) {
        api__data.image1 = weather.image1 ?? "";
        api__data.image2 = weather.image2 ?? "";
        api__data.image3 = weather.image3 ?? "";
        api__data.image4 = weather.image4 ?? "";
        api__data.image5 = weather.image5 ?? ""; // TODO: remove once API removes image5
        api__data.image6 = weather.image6 ?? ""; // TODO: remove once API removes image6
      }
      return saveWeather(api__data);
    },
  });

export default useSaveWeather;
